export const tr = {
    datepicker: {
        months: [
            'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'
        ],
        monthsShort: [
            'Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'
        ],
        weekdays: [
            'Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'
        ],
        weekdaysShort: [
            'Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'
        ],
        weekdaysNarrow: [
            'P', 'P', 'S', 'Ç', 'P', 'C', 'C'
        ],
        timesOfDay: [
            'a.m.', 'p.m.'
        ],
        timesOfDayUppercase: [
            'AM', 'PM'
        ],
        timesOfDayLowercase: [
            'am', 'pm'
        ],
        formats: {
            time: 'h:mm A',
            datetime: 'D MMMM YYYY h:mm A',
            date: 'D MMMM YYYY',
            month: 'MMMM YYYY',
            year: 'YYYY'
        },
        firstDayOfWeek: 1
    },
    search: {
        placeholder: 'Ara...',
        noResults: {
            header: 'Sonuç Yok',
            message: 'Aramaya uygun sonuç bulunamadı'
        }
    },
    select: {
        noResultsMessage: 'Sonuç Yok',
        single: {
            placeholder: 'Seçiniz'
        },
        multi: {
            placeholder: 'Seçiniz...',
            maxSelectedMessage: 'Maks #{max} seçim',
            selectedMessage: '#{count} seçildi'
        }
    }
};
// # sourceMappingURL=en-GB.js.map



// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/assets/semantic/src/locales/tr.ts